import React, { useContext, useEffect, useMemo, useState } from "react";
import style from "./index.module.scss";

import { rootContext } from "@/context/rootContext";
import { isFl84 } from "@/common/utils/envData";
import Api from "@/common/Api/message";
import filterGameData from "@/assets/data/gameData";

function Task(props) {

  const [task3List, setTask3List] = useState([]);
  const [doneStatus, setDoneStatue] = useState([]);
  const { guideTask, setGuideTask, setDialogIndex, creatorData, enterRegion, globalLang, langState } = useContext(rootContext);
  const blockTask = useMemo(() => filterGameData("blockTask"), [enterRegion, creatorData]);

  const openTaskCard = (doneStatus) => {
    setTimeout(() => {
      task3List[0].done = true;
      setTask3List([...task3List]);
    }, 1000);
    setTimeout(() => {
      task3List[1].done = true;
      task3List[3].done = true;
      setTask3List([...task3List]);
    }, 1200);
    setTimeout(() => {
      task3List[2].done = true;
      task3List[4].done = true;
      task3List[6].done = doneStatus[6];
      setTask3List([...task3List]);
    }, 1400);
    setTimeout(() => {
      task3List[5].done = true;
      task3List[7].done = doneStatus[7];
      setTask3List([...task3List]);
    }, 1600);
    setTimeout(() => {
      task3List[8].done = doneStatus[8];
      setTask3List([...task3List]);
    }, 1800);
    if (doneStatus.reduce((total, item) => total + (item ? 1 : 0)) >= doneStatus.length - blockTask.length) {
      props.finFun();
    }
  };

  useEffect(() => {
    if (guideTask.length) {
      setTask3List(guideTask.map(item => {
        return {
          ...item,
          done: false
        };
      }));
      const doneList = guideTask.map(item => item.done);
      setDoneStatue(doneList);
      if (doneList.reduce((total, item) => total + (item ? 1 : 0)) === doneStatus.length) {
        props.finFun();
      }
    }
  }, [guideTask]);

  useEffect(() => {
    if (guideTask.length && task3List.length) {
      openTaskCard(doneStatus);
    }
  }, [doneStatus]);

  const comfirmTask = (index) => {
    switch (index) {
      case 6:
        tiersExplained(index);
        break;
      case 7:
        openWelcome(index);
        break;
    }
  };

  // 查看层级弹窗
  const tiersExplained = (index) => {
    window.gtag("event", "m_check_tiers");
    setDialogIndex(14);
    if (!doneStatus[index]) {
      finishTask(guideTask[index].taskId, index, null);
    }
  };

  // Join the Crator Discord Channel+
  const joinDiscord = () => {
    const link = filterGameData("discordLink");
    return link || "javascript:;";
  };

  const finishJoinDiscord = (index) => {
    if (!guideTask[index].done) {
      finishTask(guideTask[index].taskId, index, null);
    }
  };

  // welcome video
  const openWelcome = (index) => {
    window.gtag("event", "m_welcome");
    if (!isFl84) {
      setDialogIndex(15);
    }
    if (!guideTask[index].done) {
      finishTask(guideTask[index].taskId, index, null);
    }
  };

  const finishTask = async (id, index, callback) => {
    const res = await Api.finishTask({ id });
    if (res.status === 200) {
      task3List[index].done = true;
      setTask3List([...task3List]);
      // console.log(guideTask[index], guideTask[index].done);
      guideTask[index].done = true;
      setGuideTask([...guideTask]);
      // doneStatus[index] = true;
      // setDoneStatue([...doneStatus]);
      if (callback) {
        callback();
      }
    }
  };

  const filterRegionText = (item) => {
    if (globalLang !== "en") {
      return (langState.guideData.guideTask && langState.guideData.guideTask[item.taskId]) || item.content;
    }
    return item.content;
  };

  const filterDom = (item, index) => {
    const text = filterRegionText(item);
    if (index === 8) {
      return (
        <a href={joinDiscord()} onClick={() => { finishJoinDiscord(index); window.gtag("event", "m_discord"); }} target="_blank" rel="noreferrer">
          <p>{text}</p>
        </a>
      );
    }
    if (isFl84 && index === 7) {
      return (
        <a href="https://www.youtube.com/watch?v=jumeWtPGtEQ" target="_blank" rel="noreferrer" onClick={() => { comfirmTask(index); }}>
          <p>{filterRegionText(item)}</p>
        </a>
      );
    }
    return <p>{text}</p>;
  };

  return (
    <div className={style.community_rules_box2}>
      {
        task3List.map((item, index) => {
          return (
            <div className={`${style.task_item}  ${item.done ? style.active : ""} ${blockTask.includes(+item.taskId) ? style.none : ""}`} key={index} onClick={() => { comfirmTask(index); }}>
              <div className={style.task_data}>
                { filterDom(item, index) }
              </div>
              <div className={style.task_default}>
                {/* <p>{item.content}</p> */}
              </div>
            </div>
          );
        })
      }
    </div>
  );
}

const TaskMemo = React.memo(Task);

export default TaskMemo;